import LoadingComponent from "../../../../../components/LoadingComponent.jsx";
import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {FilterContext} from "../../../../../components/filters/DashboardFilterContextProvider.jsx";
import {ErpCalculationApi} from "../../../../../api/authority/generated/index";
import {useErrorTranslation} from "../../../../../api/utilities/translateErrorMessage.js";
import useAuthorityConfiguration from "../../../../../api/utilities/useAuthorityConfiguration.js";
import toast from "react-hot-toast";
import SeeMore from "../../../../../components/SeeMore.jsx";
import {useTopChannelColumns} from "../../../topChannelColumns.js";
import DataGrid2 from "../../../../../components/datagrid/DataGrid2.jsx";

export default function ChannelPerformancePanel({project}) {
    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let {since, until, centresAllowListed, domainsAllowListed} = useContext(FilterContext);

    let [data, setData] = useState(null);
    let [dataLoading, setDataLoading] = useState(true);
    let authorityConfiguration = useAuthorityConfiguration()

    let columns = useTopChannelColumns(project);

    useEffect(() => {
        if (!project) {
            return;
        }

        let active = true;
        setDataLoading(true);

        new ErpCalculationApi(authorityConfiguration)
            .channelPerformance({
                projectId: project.id,
                erpFilter: {
                    since: since.format('YYYY-MM-DD'),
                    until: until.format('YYYY-MM-DD'),
                    selectedCentreIds: centresAllowListed,
                    selectedDomainIds: domainsAllowListed,
                },
            })
            .then((nextData) => {
                if (!active) {
                    return;
                }

                setData(nextData);
                setDataLoading(false);
            })
            .catch(e => {
                if (!active) {
                    return;
                }

                setDataLoading(false);
                et(e).then(toast.error);
            });

        return () => {
            active = false;
        };

    }, [project?.id, since, until, centresAllowListed, domainsAllowListed]);

    return (<LoadingComponent
            loading={dataLoading || !data}
            className="comp__roundedBox flex flex-col justify-between col-span-12 xl:col-span-6 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700"
        >
            <header
                className={'px-5 py-4 border-b border-gray-100 dark:border-gray-700/60'}>
                <h2 className={'font-semibold text-gray-800 dark:text-gray-100'}>
                    {t('orders.top-channels')}
                </h2>
            </header>
            <div className={'p-3'}>
                {<SeeMore heightClass={'h-[223px]'} active={(data?.topChannels.length ?? 0) >= 5}>
                    <DataGrid2
                        showHeader={true}
                        columns={columns}
                        dataSource={data?.topChannels}
                    />
                </SeeMore>}
            </div>
        </LoadingComponent>
    );

}
